var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterWhite16X16 = function SvgTwitterWhite16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54898",
    transform: "translate(-72 -642)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4355",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(72 642)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81 651)",
    "data-name": "Component 2301 \\u2013 2"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 20963",
    width: 32,
    height: 32,
    rx: 6,
    fill: "none",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4586"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108567",
    d: "M11.496 13.62 7.947 8.874c.176-.009.29-.021.4-.021 1.248 0 2.5.007 3.744-.007a.66.66 0 0 1 .612.3c1.1 1.5 2.226 2.991 3.343 4.484.088.118.182.231.327.413.112-.143.2-.267.3-.376 1.358-1.471 2.727-2.932 4.072-4.415a1.016 1.016 0 0 1 .952-.4 6.8 6.8 0 0 0 .769 0l-5.523 5.968 6.164 8.245c-.033.04-.049.076-.065.076-1.4 0-2.8.015-4.2 0a.692.692 0 0 1-.437-.287c-1.249-1.651-2.485-3.311-3.725-4.969-.08-.107-.167-.21-.266-.334l-3.481 3.76c-.447.483-.915.949-1.334 1.455a.949.949 0 0 1-.917.392 7.8 7.8 0 0 0-.794 0l5.934-6.413-2.331-3.117m4.485 1.563q-1.9-2.536-3.8-5.067a.62.62 0 0 0-.367-.264c-.609-.028-1.22-.012-1.893-.012.114.166.186.277.265.382l1.8 2.4q3.448 4.61 6.9 9.217c.1.13.251.3.386.306.609.033 1.222.014 1.927.014Z",
    fill: "#f8f8f8"
  }))))));
};
export default SvgTwitterWhite16X16;